export default __webpack_public_path__ + "static/media/NRPA-RGB Horizontal Scaled 960.f62e68c0.png";